<lib-gung-tabset orientation="vertical" [activeId]="activeTabId"  [collapsible]="true" [sidebarLabel]="'SETTINGS' | translate" (tabChange)="onTabChange($event)">
  @for (item of gungSettingsMenu; track item; let idx = $index) {
    @if (!item.hide && !item.isSeparator) {
      <lib-gung-tab [id]="item.id" [disabled]="!!item.disabled" [icon]="item.prependIcon">
        <ng-template libGungTabTitle>
          <i style="min-width: 1rem" *ngIf="item.prependIcon" [class]="item.prependIcon + ' mr-2'"></i>
          <span>{{ item.translationLabel | translate }}</span>
          <i *ngIf="item.appendIcon" [class]="item.appendIcon + ' ml-2'"></i>
        </ng-template>
        <ng-template libGungTabContent>
          <ng-container *ngComponentOutlet="item.componentView"></ng-container>
        </ng-template>
      </lib-gung-tab>
    }
  }
</lib-gung-tabset>
